export default {"src":"/app/_next/static/media/dot.a52d791b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};